import {
  AccMgtIcon,
  ClientIcon,
  DashIcon,
  LogIcon,
  SettingsIcon,
  StaffIcon,
} from "./images";
import { BsTrash } from "react-icons/bs";
import { IoPersonRemoveOutline } from "react-icons/io5";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { PRIVATE_PATHS } from "../../routes/constants";

export const adminRoutes = [
  {
    id: 0,
    name: "Dashboard",
    path: "/dashboard",
    icon: <DashIcon size={50} fill="#080761" />,
    hover: <DashIcon size={50} fill="#fff" />,
    sec: <DashIcon size={50} fill="#fff" />,
  },

  {
    id: 1,
    name: "Staff",
    icon: <StaffIcon fill="#080761" />,
    hover: <StaffIcon fill="#080761" />,
    sec: <StaffIcon fill="#fff" />,
    path: "/staff",
  },

  {
    id: 2,
    name: "Work Log",
    path: "/work-log",
    icon: <LogIcon fill="#080761" />,
    hover: <LogIcon fill="#080761" />,
    sec: <LogIcon fill="#fff" />,
  },

  {
    id: 3,
    name: "Client Management",
    icon: <ClientIcon fill="#080761" />,
    hover: <ClientIcon fill="#080761" />,
    sec: <ClientIcon fill="#fff" />,
    path: "/client-mgt",
  },

  {
    id: 4,
    name: "Account Management",
    path: "/account-mgt",
    icon: <AccMgtIcon fill="#080761" />,
    hover: <AccMgtIcon fill="#080761" />,
    sec: <AccMgtIcon fill="#fff" />,
  },
  {
    id: 5,
    name: "Settings",
    parent: "/settings",
    path: "/settings/departments",
    icon: <SettingsIcon fill="#080761" />,
    hover: <SettingsIcon fill="#080761" />,
    sec: <SettingsIcon fill="#fff" />,
  },
];

export const altCustomStyles = () => ({
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    minHeight: "44px",
    color: "#0C0D10",
    fontSize: "16px",
    cursor: "pointer",
    borderRadius: "8px",
    border: "none",
    paddingRight: "16px",
    background: state.hasValue ? "#F5FCFB" : "unset",
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "15px",
    backgroundColor: "#fff",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "" : "",
    cursor: "pointer",
    backgroundColor: state.isFocused ? "#F8FDFC" : "",
  }),
});

export const customStyles = (error) => ({
  control: (provided, state) => ({
    ...provided,
    width: "100%",
    minHeight: "44px",
    color: error ? "#EE383A" : "#0C0D10",
    fontSize: "16px",
    cursor: "pointer",
    borderRadius: "8px",
    border: error
      ? "1px solid red"
      : state.hasValue
        ? "1px solid #01ACF0"
        : "1px solid #C5C5CF",
    paddingRight: "16px",
    background: error ? "#FDE8E8" : state.hasValue ? "#F5FCFB" : "unset",
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "15px",
    backgroundColor: "#fff",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "" : "",
    cursor: "pointer",
    backgroundColor: state.isFocused ? "#F8FDFC" : "",
  }),
});

export const staffTabs = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Inactive",
    value: "inactive",
  },
];

export const clientTabs = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Active",
    value: "active",
  },
  {
    label: "Inactive",
    value: "inactive",
  },
  {
    label: "Dormant",
    value: "dormant",
  },
];

export const strategyRoute = [
  {
    label: "Probable Products",
    route: PRIVATE_PATHS.CLIENT_MGT_PROBABLE_PRODUCTS,
  },
  {
    label: "Strategy Adopted",
    route: PRIVATE_PATHS.CLIENT_MGT_STRATEGY_ADOPTED,
  },
];

export const adminOption = [
  "View",
  "Activate",
  "Deactivate",
  "Resend Invite",
  "Delete",
];

export const viewDelete = ["View", "Delete", "Assign"];

export const Statuses = [
  { color: "#F9A11E", name: "Pending", id: "0" },
  { color: "#646668", name: "InProgress", id: "1" },
  { color: "#01765F", name: "Active", id: "2" },
  { color: "#DB0101", name: "Failed", id: "3" },
  { color: "#A11212", name: "Rejected", id: "4" },
];

export const TeamStatus = [
  { color: "#646668", name: "All", id: "" },
  { color: "#0B841D", name: "Active", bg: "#E5FFE5", id: "2" },
  { color: "#F79E1B", name: "Pending", bg: "#F8E16C33", id: "1" },
  { color: "#EE383A", name: "Inactive", bg: "#FEF1F1", id: "3" },
];

export const ClientStatus = [
  { color: "#646668", name: "All", id: "" },
  { color: "#0B841D", name: "Active", bg: "#E5FFE5", id: "2" },
  { color: "#EE383A", name: "Inactive", bg: "#FEF1F1", id: "1" },
  { color: "#EE383A", name: "Dormant", bg: "#FEF1F1", id: "0" },
  { color: "#F79E1B", name: "Pending", bg: "#F8E16C33", id: "3" },
];

export const settingsRoute = [
  { label: "Departments", route: PRIVATE_PATHS.DEPTS },
  { label: "System Roles", route: PRIVATE_PATHS.SYSTEM_ROLES },
  { label: "Permissions", route: PRIVATE_PATHS.PERMISSIONS },
  // { label: "Strategy", route: PRIVATE_PATHS.STRATEGY },
];

export const workLogRoute = [
  { label: "Operations", route: PRIVATE_PATHS.WORK_LOG },
  { label: "Digital Marketer", route: PRIVATE_PATHS.DIGITAL_MARKETER },
  { label: "Finance Activity", route: PRIVATE_PATHS.FNANCE_ACTIVITY },
  { label: "Sales Activity", route: PRIVATE_PATHS.SALES_ACTIVITY },
];

export const clientsRoute = [
  { label: "Leads", route: PRIVATE_PATHS.CLIENT_MGT_LEADS },
  { label: "Clients", route: PRIVATE_PATHS.CLIENT_MGT_CLIENTS },
];

export const workLogTabs = [
  {
    label: "All",
    value: "",
  },
  {
    label: "Pending",
    value: 1,
  },
  {
    label: "Completed",
    value: 2,
  },
];

export const staffPerformanceTabs = [
  {
    label: "Day",
    value: "daily",
  },
  {
    label: "Week",
    value: "weekly",
  },
  {
    label: "Month",
    value: "monthly",
  },
];

export const workLogStatus = [
  { color: "#EE383A", name: "All", id: "" },
  { color: "#0B841D", name: "Completed", bg: "#E5FFE5", id: "2" },
  { color: "#F79E1B", name: "Pending", bg: "#F8E16C33", id: "1" },
];

export const dashboardRevenueTabs = [
  { label: "Week", value: "week" },
  { label: "Month", value: "month" },
  // { label: "Year", value: "year" },
];

export const RevenueOverviewData = [
  { name: "Clients", value: 121 },
  { name: "Successful Transaction", value: 2345 },
  { name: "Revenue", value: 20050523 },
];

export const roleTabs = [
  {
    label: "Super Admin",
    value: 1,
  },
  {
    label: "Admin",
    value: 2,
  },
  {
    label: "Manager",
    value: 3,
  },
];

// permissionsData.js
export const permissionsData = [
  {
    category: "System Administration",
    actions: [
      "Manage all user roles and permissions",
      "View all",
      "Manage Client Information",
      "Generate Reports",
    ],
  },
  {
    category: "Management",
    actions: [
      "View all information",
      "Input Information",
      "Deactivate",
      "Activate",
    ],
  },
  {
    category: "Admin",
    actions: ["Input/Editing", "View Client Information", "Delete", "Manage"],
  },
  {
    category: "Reporting & Analytics",
    actions: [
      "Access all report requests and dashboards",
      "Analyze system performance and user activity",
      "Generate custom reports",
    ],
  },
  {
    category: "Department Management",
    actions: ["Create", "Edit", "Deactivate", "Delete"],
  },
];

export const SocialMediaPlatforms = [
  "Facebook",
  "YouTube",
  "WhatsApp",
  "Instagram",
  "WeChat",
  "TikTok",
  "Telegram",
  "Snapchat",
  "Douyin",
  "X (formerly Twitter)",
];
